import { fromJS } from 'immutable';

export const eqVisibleColumns = fromJS([
  'id',
  'publish',
  'year',
  'month',
  'day',
  'hour',
  'minute',
  'second',
  'locationName',
]);

export const eqSort = fromJS([
  { id: 'id', asc: true },
]);

export const tsuVisibleColumns = fromJS([
  'id',
  'publish',
  'year',
  'month',
  'day',
  'country',
  'locationName',
]);

export const tsuSort = fromJS([
  { id: 'id', asc: false },
]);

export const refVisibleColumns = fromJS([
  'id',
  'publish',
  'author',
  'year',
  'citation',
]);

export const refSort = fromJS([
  { id: 'id', asc: false },
]);

export const volLocVisibleColumns = fromJS([
  'id',
  'num',
  'name',
  'country',
]);
export const volLocSort = fromJS([
  { id: 'name', asc: true },
]);

export const volVisibleColumns = fromJS([
  'id',
  'significant',
  'year',
  'month',
  'day',
  'country',
  'name',
]);
export const volSort = fromJS([
  { id: 'name', asc: false },
]);

export const minColumns = fromJS([]);
